import React from "react";
import "./projectComponent.css";
import OptimizedSlideshow from './OptimizedSlideshow';
import RNE1 from "./images/RNE1.png";
import RNE2 from "./images/RNE2.png";
import RNE3 from "./images/RNE3.png";
import RNE4 from "./images/RNE4.png";
import RNE5 from "./images/RNE5.png";


const RNEBot = () => {
    const mediaItems = [
        {
            type: 'image',
            src: RNE1,
        },
        {
            type: 'image',
            src: RNE2,
        },
        {
            type: 'image',
            src: RNE3,
        },
        {
            type: 'image',
            src: RNE4,
        },
        {
            type: 'image',
            src: RNE5,
        }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">RNEBot</h2>
        <span className="section__subtitle">AI Chatbot for RNE Tunisia</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
            <div className="text__container">
                <h3 className="title">Description:</h3>
                <br />
                <p className='redRadio__text'>
                    RNEBot is a large-scale RAG (Retrieval-Augmented Generation) system developed as a team project for RNE Tunisia. 
                    Designed to serve Tunisian citizens with comprehensive assistance for all company-related processes.
                </p>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Core Features</h4>
                <ul style={{listStyle: 'none', padding: '0', margin: '0'}}>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🏢 Company Creation Guidance</strong> - Step-by-step assistance for establishing new businesses
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>📝 Document Updates</strong> - Help with company registration updates and modifications
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>⚡ Real-time Knowledge Updates</strong> - Instant document integration via admin dashboard
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🔍 Web Search Integration</strong> - Custom workflow to enhance chatbot responses with live data
                    </li>
                    <li className='redRadio__text' style={{marginBottom: '0.5rem'}}>
                        <strong>🇹🇳 Tunisia-Specific</strong> - Tailored for Tunisian business regulations and procedures
                    </li>
                </ul>
                <br />
                
                <h4 className="title" style={{fontSize: '1.1rem', marginBottom: '0.5rem'}}>Technical Architecture</h4>
                <p className='redRadio__text'>
                    Advanced RAG system with dynamic document ingestion, intelligent retrieval mechanisms, and web search capabilities 
                    to provide accurate, up-to-date information for complex business processes.
                </p>
                <br />
                
                <p className='redRadio__text' style={{fontStyle: 'italic'}}>
                    Streamlining business operations for Tunisian entrepreneurs through intelligent AI assistance.
                </p>
            </div>

            <div className="skills__container1 container grid">
        <div className="skills__content">
        <h3 className="skills__title">Technologies Used</h3>

        <div className="skills__box">

        <div className="skills__group">

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Python</h3>
                <span className="skills__level">Backend</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">RAG</h3>
                <span className="skills__level">AI</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">LLMs</h3>
                <span className="skills__level">AI</span>
            </div>
            </div>

        </div>

        <div className="skills__group">


            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">NextJS</h3>
                <span className="skills__level">Frontend</span>
            </div>
            </div>
            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Agents</h3>
                <span className="skills__level">Search</span>
            </div>
            </div>

            <div className="skills__data">
            <i class="bx bx-badge-check"></i>
            <div>
                <h3 className="skills__name">Docker</h3>
                <span className="skills__level">Deployment</span>
            </div>
            </div>
          
        </div>

        </div>
    </div>
            </div>
        </div>
    </section>
    );
};

export default RNEBot;